import userConstants from '../constants';

const initialState = {
  isFetching: false,
  error: null,
};

export function userCreate(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case userConstants.CREATE_USER_REQUEST:
      return {
        isFetching: true,
        error: null,
      };
    case userConstants.CREATE_USER_SUCCESS:
      return {
        isFetching: false,
        error: null,
      };
    case userConstants.CREATE_USER_FAILURE:
      return {
        isFetching: false,
        error: payload,
      };
    default:
      return state;
  }
}
